import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './tire-model.reducer';

export const TireModelDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const hasDeleted = useRef(false);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireModelEntity = useAppSelector(state => state.tireModel.entity);
  const updateSuccess = useAppSelector(state => state.tireModel.updateSuccess);

  const handleClose = () => {
    props.history.push('/tire-model' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess && hasDeleted.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    hasDeleted.current = true;
    dispatch(deleteEntity(tireModelEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="tireModelDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.tireModel.delete.question">
        <Translate contentKey="fleetSenseApp.tireModel.delete.question" interpolate={{ id: tireModelEntity.name }}>
          Are you sure you want to delete this TireModel?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-tireModel" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TireModelDeleteDialog;
